"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DueDateCalendar = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../token/icons");
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tooltipV2_1 = require("../tooltipV2");
var styles_1 = require("./styles");
var mesNumeralParaMesString = function (mesNumero) {
    var mesesString = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return mesesString[mesNumero - 1];
};
var formatarPrazoEntrega = function (prazoEntrega) {
    if (!prazoEntrega || prazoEntrega === '' || prazoEntrega === 'Invalid DateTime') {
        return ['--', ''];
    }
    var prazoEntregaSeparado = prazoEntrega.split('/');
    var diaEntrega = parseInt(prazoEntregaSeparado[0]);
    var mesEntregaNumber = parseInt(prazoEntregaSeparado[1]);
    var mesEntrega = mesNumeralParaMesString(mesEntregaNumber);
    return [diaEntrega.toString(), mesEntrega];
};
var DueDateCalendar = function (_a) {
    var prazoEntrega = _a.prazoEntrega;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var _b = formatarPrazoEntrega(prazoEntrega), diaEntrega = _b[0], mesEntrega = _b[1];
    return (react_1.default.createElement(styles_1.ComponentCalendarWrapperStyled, null,
        react_1.default.createElement(tooltipV2_1.TooltipV2Card, { top: true },
            react_1.default.createElement(tooltipV2_1.TooltipV2Content, null,
                react_1.default.createElement(icons_1.CalendarLight, { width: "80px", height: "80px", stroke: theme.p003 }),
                react_1.default.createElement(styles_1.ComponentDataWrapperStyled, null,
                    react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, color: theme.grey001, className: "dueDateDay" }, diaEntrega),
                    react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, color: theme.grey001, className: "dueDateMonth" }, mesEntrega))),
            react_1.default.createElement(tooltipV2_1.TooltipV2Box, { top: true }, mesEntrega === '' ? (react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, color: theme.white }, "Prazo de entrega: a definir")) : (react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, color: theme.white }, "Prazo de entrega"))))));
};
exports.DueDateCalendar = DueDateCalendar;
